import { Occupancy } from '@model/state';
import { INITIAL_PRICE_CALENDAR_FILTERS_STATE } from '@state/slices/price-calendar/filter/priceCalendarFilterSlice';
import { createSelector } from 'reselect';
import { Filters, PriceCalendarFiltersState, PriceCalendarState } from '@model/state/price-calendar-state';
import { hasChildrenWithErrors } from '@model/search';
import { getPriceCalendarState } from '@state/slices/price-calendar/monthly/priceCalendarMonthlySelectors';

export const getPriceCalendarFilters = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): PriceCalendarFiltersState => state.filters
);
export const getPriceCalendarFiltersDuration = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): number => state.filters.duration
);
export const getPriceCalendarFiltersOccupancy = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): Array<Occupancy> => state.filters.occupancy
);
export const getPriceCalendarFiltersAirport = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): string => state.filters.airport
);
export const getPriceCalendarFiltersBoard = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): string => state.filters.board
);
export const getIsPriceCalendarFiltersLoading = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): boolean => state.filters.response.loading
);
export const getIsPriceCalendarFiltersEmpty = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): boolean => state.filters === INITIAL_PRICE_CALENDAR_FILTERS_STATE
);
export const getPriceCalendarFiltersHasError = createSelector(
  getPriceCalendarState,
  (state: PriceCalendarState): boolean => state.filters.response.error
);
export const getPriceCalendarOccupancyError = createSelector(getPriceCalendarFilters, (filters: Filters) => {
  return !filters.occupancy || hasChildrenWithErrors(filters.occupancy);
});
